import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AccountManagementRoute, AdminRoute, PriceEditorRoute, ProtectedRoute } from './ProtectedRoute';
import { FeatureRoute } from './FeatureRoute';
import { AppLayout } from './AppLayout';
import { Skeleton } from '../components/ui';

const LoginPage = lazy(() => import('../pages/LoginPage').then((module) => ({ default: module.LoginPage })));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then((module) => ({ default: module.DashboardPage })));
const CalculatorPage = lazy(() => import('../pages/CalculatorEntryPage').then((module) => ({ default: module.CalculatorEntryPage })));
const QuotesPage = lazy(() => import('../pages/QuotesPage').then((module) => ({ default: module.QuotesPage })));
const QuoteDetailPage = lazy(() => import('../pages/QuoteDetailPage').then((module) => ({ default: module.QuoteDetailPage })));
const AdminPricingPage = lazy(() => import('../pages/AdminPricingPage').then((module) => ({ default: module.AdminPricingPage })));
const AdminPriceEditorPage = lazy(() => import('../pages/AdminPriceEditorPage').then((module) => ({ default: module.AdminPriceEditorPage })));
const AdminReviewPage = lazy(() => import('../pages/AdminReviewPage').then((module) => ({ default: module.AdminReviewPage })));
const ApprovalsPage = lazy(() => import('../pages/ApprovalsPage').then((module) => ({ default: module.ApprovalsPage })));
const AdminApprovalsPage = lazy(() => import('../pages/AdminApprovalsPage').then((module) => ({ default: module.AdminApprovalsPage })));
const AccountPage = lazy(() => import('../pages/AccountPage').then((module) => ({ default: module.AccountPage })));
const InstructionsPage = lazy(() => import('../pages/InstructionsPage').then((module) => ({ default: module.InstructionsPage })));
const AdminUsersPage = lazy(() => import('../pages/AdminUsersPage').then((module) => ({ default: module.AdminUsersPage })));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })));

export function App() {
  return (
    <Suspense fallback={<div className="grid min-h-[60vh] place-items-center"><Skeleton className="h-32 w-full max-w-xl" /></div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="calculator/new" element={<CalculatorPage />} />
            <Route path="quotes" element={<QuotesPage />} />
            <Route path="quotes/:id" element={<QuoteDetailPage />} />
            <Route path="approvals" element={<ApprovalsPage />} />
            <Route path="instructions" element={<InstructionsPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route element={<AccountManagementRoute />}>
              <Route path="admin/users" element={<AdminUsersPage />} />
            </Route>
            <Route element={<PriceEditorRoute />}>
              <Route path="admin/prices" element={<AdminPriceEditorPage />} />
            </Route>
            <Route element={<AccountManagementRoute />}>
              <Route element={<AdminRoute />}>
                <Route element={<FeatureRoute feature="priceAdministration" />}>
                  <Route path="admin/pricing" element={<AdminPricingPage />} />
                  <Route path="admin/review" element={<AdminReviewPage />} />
                </Route>
                <Route element={<FeatureRoute feature="approvalWorkflowAdministration" />}>
                  <Route path="admin/approvals" element={<AdminApprovalsPage />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
